import { Container } from 'react-bootstrap';
import NavBar from './NavBar';
import SideBar from './SideBar';

interface ChildrenElement {
  children?: JSX.Element | JSX.Element[] | HTMLElement;
  // eslint-disable-next-line react/require-default-props
  showLoggedComponents?: boolean;
}

const Layout = ({ children, showLoggedComponents = true }: ChildrenElement) => (
  <Container fluid className="p-0 d-flex flex-column vh-100">
    <NavBar showLoggedComponents={showLoggedComponents} />
    <div className="d-flex flex-fill overflow-hidden">
      {showLoggedComponents && <SideBar />}
      <main className="flex-fill overflow-auto d-flex flex-column">{children}</main>
    </div>
  </Container>
);

export default Layout;
